/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import { Grid, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { themes } from '../../themes/themes';

interface ICustomTextFieldProps {
  label?: string;
  helperText?: string;
  value?: any;
  defaultValue?: any;
  placeholder?: string;
  onChange?: any;
  type: string;
  disabled?: any;
  variant?: any;
  multiline?: boolean;
  rows?: number;
  inputProps?: any;
  InputProps?: any;
  errors?: ReactNode;
}

const StyledTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: themes.primary,
    fontFamily: 'Lato',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: themes.primary,
    color: themes.primary,
  },
  '& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': {
    font: 'normal normal normal 14px/24px Lato',
  },
  '& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
    fontSize: '0.85em',
    fontFamily: 'Lato',
  },
});
const CustomTextField = ({
  helperText,
  label,
  onChange,
  placeholder,
  value,
  defaultValue,
  type,
  disabled,
  variant = 'outlined',
  multiline = false,
  rows,
  inputProps,
  InputProps,
  errors,
}: ICustomTextFieldProps) => {
  return (
    <Grid item xs={12}>
      <StyledTextField
        label={label}
        helperText={helperText || errors}
        variant={variant}
        fullWidth
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        onChange={onChange}
        type={type}
        disabled={disabled}
        rows={rows}
        multiline={multiline}
        inputProps={inputProps}
        InputProps={InputProps}
        error={errors ? true : false}
      />
    </Grid>
  );
};

export default CustomTextField;
